<template>
  <div v-if="videoRoomMaster" class="w-100">
    <proa-card class="h-100 d-flex flex-column">
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center">
          <proa-back-button
            @onClick="onClickBackButton"
          />
          <proa-heading detail class="room-name">
            <span>
              <img :src="require('@/assets/images/icons/meeting_room.png')" />
              <span>{{ videoRoomMaster.roomName }}</span>
            </span>
          </proa-heading>
          <div>
            <span class="prefix-max">{{ $t('common.max') }}</span>
            <span>{{ videoRoomMaster.roomCapacity + $t('common.person') }}</span>
          </div>
        </div>
      </template>
      <div class="reservations-content">
        <table>
          <tbody>
            <tr>
              <th>
                <span v-if="videoRoomMaster.roomType === 'cafeRoom'">
                  {{ $t('pages.meeting.membersInUsed') }}（{{ videoRoomMaster.getCurrentCafeInfoUsers().length + $t('common.person') }}）
                </span>
                <span v-else>{{ $t('pages.meeting.reservedList') }}</span>
              </th>
            </tr>
          </tbody>
        </table>
        <div class="video-rooms-container">
          <div class="video-rooms">
            <div class="video-rooms-innner-scroll-wrapper">
              <div
                v-for="videoRoom in videoRooms"
                :key="videoRoom.id"
                @click="onClickVideoRoom(videoRoom.id)"
                :class="['video-room', { 'cafe': videoRoomMaster.roomType === 'cafeRoom' }]"
              >
                <template v-if="videoRoomMaster.roomType === 'cafeRoom'">
                  <div class="cafe-members-container">
                    <div
                      v-for="user in videoRoom.getUsers()"
                      :key="user.id"
                      :class="[
                        'cafe-member-wrapper',
                        { 'joined': videoRoom.joinedUserIds.includes(user.id) }
                      ]"
                    >
                      <proa-avatar
                        :src="user.meta.avatar || require('@/assets/images/avatar_default.png')"
                        size="sm"
                      />
                      <span>{{ user.meta.displayName }}</span>
                    </div>
                  </div>
                  <proa-button
                    v-if="videoRoom.userIds.includes(signedInUser.id)"
                    variant="primary"
                    @click.native.stop="onClickEnterCafeRoom(videoRoom.id)"
                  >
                    {{ $t('common.join') }}
                  </proa-button>
                </template>
                <template v-else>
                  <div class="reservation-at">
                    <span class="mr-2">{{ videoRoom.startAt | moment('YYYY年MM月DD日（ddd）') }}</span>
                    <span>{{ videoRoom.startAt | moment('HH:mm') }}〜{{ videoRoom.endAt | moment('HH:mm') }}</span>
                  </div>
                  <div class="meeting-title">
                    {{ videoRoom.meetingTitle }}
                  </div>
                  <proa-avatar v-if="videoRoom.getOwner()" :src="videoRoom.getOwner().meta.avatar || require('@/assets/images/avatar_default.png')" size="xs"/>
                  <span v-if="videoRoom.getOwner()" class="room-owner-name">{{ videoRoom.getOwner().meta.displayName }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="signedInUser.creatable" class="reservations-footer">
        <proa-button
          v-if="videoRoomMaster.roomType === 'cafeRoom'"
          @click.native="inviteCafeRoomMembersModal = true"
          class="default-button-width"
        >
          {{ $t('common.inviteNow') }}
        </proa-button>
        <proa-button
          v-else
          @click.native="onClickNewReservation"
          class="default-button-width"
        >
          {{ $t('common.newReservation') }}
        </proa-button>
      </div>
    </proa-card>
    <select-member-modal
      v-if="newCafeRoom"
      :modal="inviteCafeRoomMembersModal"
      :userIds="newCafeRoom.userIds"
      :upperLimit="videoRoomMaster.roomCapacity - newCafeRoom.userIds.length"
      type="inviteCafeRoom"
      @close="inviteCafeRoomMembersModal = false"
      @confirm="addCafeRoomUserIds"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VideoRoomMaster from '@/store/models/VideoRoomMaster'
import VideoRoom from '@/store/models/VideoRoom'

import SelectMemberModal from '@/components/organisms/SelectMemberModal'

export default {
  name: 'IndexMeetingReservations',
  components: {
    SelectMemberModal
  },
  computed: {
    returnPath: function() { return this.$route.params.returnPath },
    videoRoomMasterId: function() { return this.$route.params.id },
    videoRoomMaster: function() { return VideoRoomMaster.find(this.videoRoomMasterId) },
    videoRooms: function() {
      return VideoRoom.query().where((videoRoom) => {
        return videoRoom.videoRoomMasterId == this.videoRoomMasterId
               && (this.videoRoomMaster.roomType != 'cafeRoom' || videoRoom.joinedUserIds.length > 0)
      }).orderBy('startAt', 'asc').get()
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  data(){
    return {
      inviteCafeRoomMembersModal: false,
      newCafeRoom: null,
    }
  },
  methods: {
    onClickBackButton: function() {
      if (this.returnPath) {
        this.$router.push({ path: `/${this.returnPath}` })
      } else {
        this.$router.push({ name: 'meeting' })
      }
    },
    onClickVideoRoom: function(id) {
      if (this.videoRoomMaster.roomType === 'cafeRoom') return
      this.$router.push({ name: 'showMeetingReservations', params: { videoRoomMasterId: this.videoRoomMasterId, id: id } })
    },
    onClickEnterCafeRoom: function(id) {
      this.$router.push({ name: 'indexRoom', params: { videoRoomMasterId: this.videoRoomMasterId, id: id } })
    },
    onClickNewReservation: function() {
      this.$router.push({ name: 'newMeetingReservations', params: { id: this.videoRoomMasterId } })
    },
    async addCafeRoomUserIds({ userIds }) {
      this.inviteCafeRoomMembersModal = false
      this.newCafeRoom.userIds = this.newCafeRoom.userIds.concat(userIds)
      const createdCafeRoomId = await this.apiPostVideoRoom({
        videoRoomMasterId: this.videoRoomMasterId,
        attributes: this.newCafeRoom
      })
      if (createdCafeRoomId) {
        this.$router.push({ name: 'indexRoom', params: { videoRoomMasterId: this.videoRoomMasterId, id: createdCafeRoomId } })
      }
    },
    ...mapActions({
      apiGetVideoRoomMaster: 'entities/videoRoomMasters/show',
      apiGetVideoRooms: 'entities/videoRooms/index',
      apiPostVideoRoom: 'entities/videoRooms/create'
    })
  },
  async created() {
    if (!this.videoRoomMaster) {
      await this.apiGetVideoRoomMaster(this.videoRoomMasterId)
      if (!this.videoRoomMaster) {
        this.$router.push({ name: 'meeting' })
      }
    }
    if (this.videoRoomMaster.roomType === 'cafeRoom') {
      this.newCafeRoom = VideoRoom.skeleton()
      this.newCafeRoom.userIds = [this.signedInUser.id]
    }
    this.apiGetVideoRooms({ videoRoomMasterId: this.videoRoomMasterId })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.room-name span {
  display: flex;
  align-items: center;

  img {
    width: 26px;
    height: 26px;
    margin-right: 10px;
  }
}

.prefix-max {
  color: $secondary-color;
  font-weight: 600;
  margin-right: 10px;
}

.reservations-content {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;

  table {
    width: 100%;

    tr {
      border-bottom: 1px solid $dark-border-color;
    }

    th {
      width: 1px;
      white-space: nowrap;
      padding: 20px 50px 20px 20px;
      font-weight: 600;
    }

    td {
      padding: 20px 0;
    }
  }

  .video-rooms-container {
    display: flex;
    flex-grow: 1;

    .video-rooms {
      position: relative;
      width: 100%;

      .video-rooms-innner-scroll-wrapper {
        position: absolute;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
      }

      .video-room {
        display: flex;
        align-items: center;
        padding: 20px;
        border-bottom: 1px solid $dark-border-color;

        &:not(.cafe) {
          cursor: pointer;

          &:hover {
            background-color: $light-gray-color;
          }
        }

        .reservation-at, .meeting-title {
          padding-right: 20px;
        }

        .room-owner-name {
          margin-left: 10px;
        }

        .cafe-members-container {
          display: flex;
          flex-grow: 1;
          flex-wrap: wrap;
          margin-top: -10px;
        }

        .cafe-member-wrapper {
          margin-top: 10px;
          &:not(.joined) {
            opacity: 0.5;
          }
          span {
            margin: 0 20px 0 10px;
          }
        }
      }
    }
  }
}

.reservations-footer {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  border-top: 1px solid $dark-border-color;
}
</style>
